import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { action, computed, makeObservable, observable } from 'mobx';

import type { EssayDto } from '@/application/interfaces/pegasus.gateway';
import { Tracking } from '@/application/utils/tracking';
import { ApplicationModel } from '@/presentation/models/application.model';
import { UserModel } from '@/presentation/models/user.model';
import { EssayStore } from '@/presentation/stores/essay.store';
import { StudentClassesStore } from '@/presentation/stores/studentClasses.store';

@ViewModel({ singleton: true })
export class FeedbackEssayViewModel implements IReactiveModel {
  @observable isLoading = true;
  @observable hasError = false;
  @observable essay: EssayDto;
  @observable essayInput: string;
  @observable essayLength = 0;
  @observable lineCount = 0;
  CHARS_PER_LINE = 10;

  constructor(
    private readonly applicationModel: ApplicationModel,
    private readonly userModel: UserModel,
    private readonly studentClassesStore: StudentClassesStore,
    private readonly essayModel: EssayStore,
  ) {
    makeObservable(this);
  }

  @action
  async onInit() {
    Tracking.pageView(this.studentClassesStore.getStudentClassesTrackingInfo());
    this.getContent();
  }

  @action.bound
  async setEssayInput(input: string) {
    this.essayInput = input;
    this.essayLength = input.length;
    this.lineCount = this.setLinesCount(input.length);
  }

  @action.bound
  async getContent() {
    try {
      this.isLoading = true;
      this.hasError = false;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.hasError = true;
    }
  }

  @action.bound
  setLinesCount(characters: number): number {
    return Math.round(characters / this.CHARS_PER_LINE);
  }

  @action.bound
  async getEssay(guid: string) {
    try {
      this.isLoading = true;
      await this.essayModel.getEssay(guid);
      this.essay = this.essayModel.currentEssay;
    } catch (error) {
      this.isLoading = false;
      this.hasError = true;
    } finally {
      this.isLoading = false;
      this.hasError = false;
    }
  }

  @computed
  get application() {
    return this.applicationModel.application;
  }

  @computed
  get user() {
    return this.userModel.user;
  }
}
